import get from 'lodash/get';
export default function getRequestHandler(moduleAPIs) {
    return async (uri, payload) => {
        const [moduleName, apiName] = uri.split('.');
        const api = get(moduleAPIs, [moduleName, apiName]);
        const result = (await api?.(...payload.args)) ?? undefined;
        return result;
    };
}
